module.exports = __webpack_public_path__ + "img/chatboticon.40c23959.png";